export enum ELinkTargets {
  'New Window' = '_blank',
  'Pop Up' = '_popup',
  'Same Window' = '_self',
}
